enum ScheduleType {
  Inbound = 'Inbound',
  TargetAirFreightOnly = 'TargetAirFreightOnly',
  TaxAirFreight = 'TaxAirFreight',
  Elwood = 'Elwood',
}

export default ScheduleType;
